module.exports = __webpack_public_path__ + "static/media/details-1-image-3.97e5a69c.jpg";